import React from 'react';
import {withDynamicComponents} from 'higher-order-components';
import HomePage from '../../containers/home-page';

import Header from '../../blocks/header';
import HeroCarousel from '../../blocks/hero-carousel';
import HeroVideo from '../../blocks/hero-video';
import HeroImage from '../../blocks/hero-image';
import SocialIconsContainerBlock from '../../containers/social-icons-container-block';
import SubFooterNavigation from '../../blocks/sub-footer-navigation';
import FooterNavigation from '../../containers/footer-navigation';
import Html from '../../containers/html';

const HomePageBlock = props => <HomePage {...props} />;
HomePageBlock.displayName = 'HomePage';

export default withDynamicComponents({
  componentWhitelist: [
    Header,
    HeroCarousel,
    HeroVideo,
    HeroImage,
    SocialIconsContainerBlock,
    SubFooterNavigation,
    FooterNavigation,
    Html,
  ],
  mapInputToOutput: [
    ['header', 'header'],
    ['hero', 'hero'],
    ['components', 'children'],
    ['footer', 'footer'],
    ['ctaNavi', 'ctaNavi'],
    ['anchorNavi', 'anchorNavi'],
    ['cookieEditor', 'cookieEditor'],
  ],
})(HomePageBlock);



// WEBPACK FOOTER //
// ./src/blocks/home-page/index.jsx